var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeOccupiedUnisexFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 19.5,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(180 63.5 19.5)",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 19.5,
    width: 63,
    height: 19,
    rx: 9.5,
    transform: "rotate(180 63.5 19.5)",
    stroke: "#ED6F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8699,
    y: 34.412,
    width: 55.0175,
    height: 48,
    transform: "rotate(-162.746 24.8699 34.412)",
    fill: "#AEB0BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeOccupiedUnisexFemale);
export default __webpack_public_path__ + "static/media/free-occupied-unisex-female.b250450ecf20ed0a6fb53869ab7e8abf.svg";
export { ForwardRef as ReactComponent };